import { tuple } from '../_util/type';
var ColumnFixedPlacements = tuple('left', 'right');


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/table/interface.js
// module id = 953
// module chunks = 1